<script setup lang="ts">
  import FlowPathInput from '@/components/form/FlowPathInput.vue'
  import { DropDown } from '@logistiek-zonder-papier/lzp-library'
  import {
    FormFieldContainer,
    InputField,
    type StringSplitElement,
  } from '@logistiek-zonder-papier/lzp-library'
  import { reactive } from 'vue'
  const field = defineModel<StringSplitElement>({ required: true })

  const touched = reactive({
    name: false,
    sourcePath: false,
    storeLocation: false,
    splitCharacter: false,
  })
  function validateRequired(
    key: 'name' | 'sourcePath' | 'storeLocation' | 'splitCharacter',
    message: string
  ) {
    return touched[key] && field.value?.type === 'stringSplit' && !field.value?.[key]?.trim()
      ? message
      : null
  }
</script>
<template>
  <div class="field-config-container">
    <FormFieldContainer label="Name" :error="validateRequired('name', 'Name is required')">
      <FlowPathInput
        placeholder="Fetch name"
        hint="Identifier for this string split step."
        v-model="field.name"
        :optional="false"
        type="text"
        :validate-paths="true"
        @blur="touched.name = true"
      />
    </FormFieldContainer>
    <FormFieldContainer
      label="Input Path"
      :error="validateRequired('sourcePath', 'SourcePath is required')"
    >
      <FlowPathInput
        placeholder="path.to.sourceString"
        hint="Where is the input value located in flow context"
        v-model="field.sourcePath"
        type="text"
        :optional="false"
        :validate-paths="true"
        @blur="touched.sourcePath = true"
      />
    </FormFieldContainer>

    <DropDown
      :modelValue="{ mode: field.mode }"
      @update:modelValue="(value: { mode: 'concat' | 'split' }) => (field.mode = value.mode)"
      required
      :data="[{ mode: 'split' }, { mode: 'concat' }]"
    >
      <template #item="{ item }"> {{ item.mode }}</template>
    </DropDown>

    <FormFieldContainer
      :label="field.mode === 'split' ? 'Split Character' : 'Concat Character'"
      :error="validateRequired('splitCharacter', 'SplitCharacter is required')"
    >
      <FlowPathInput
        placeholder="."
        :hint="
          field.mode === 'split' ? 'What character to split on' : 'What character to join with'
        "
        v-model="field.splitCharacter"
        type="text"
        :optional="false"
        :validate-paths="true"
        @blur="touched.splitCharacter = true"
      />
    </FormFieldContainer>
    <FormFieldContainer
      label="Store location"
      :error="validateRequired('storeLocation', 'Store location is required')"
    >
      <InputField
        placeholder="context.path.to.store"
        hint="Where the fetched result is stored."
        v-model="field.storeLocation"
        type="text"
        @blur="touched.storeLocation = true"
      />
    </FormFieldContainer>
  </div>
</template>
<style scoped>
  .field-config-container {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
  .test-row {
    display: flex;
    justify-content: flex-end;
    margin-top: 0.25rem;
  }
</style>
